(function () {
  if (window.__testimonialsScrollerTabindex) return;
  window.__testimonialsScrollerTabindex = true;

  var timer;

  function update() {
    document.querySelectorAll('[data-testimonials-scroller]').forEach(function (el) {
      if (el.scrollWidth > el.clientWidth) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'region');
        if (el.dataset.scrollerLabelledby) {
          el.setAttribute('aria-labelledby', el.dataset.scrollerLabelledby);
        } else if (el.dataset.scrollerLabel) {
          el.setAttribute('aria-label', el.dataset.scrollerLabel);
        }
      } else {
        el.removeAttribute('tabindex');
        el.removeAttribute('role');
        el.removeAttribute('aria-labelledby');
        el.removeAttribute('aria-label');
      }
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 150);
  }

  window.addEventListener('resize', schedule);
  window.addEventListener('load', update);
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
